import config from "@/config";

export const AGE_GATE_SCRIPT = "/age-gate.js";

/**
 * Starts the 18+ gate (public/age-gate.js) on app pages when the AGE_GATE addon is on.
 * In production the SSR template already loads the script in <head>, before the page is painted;
 * this covers the dev server and any page rendered without it. The script itself shows the gate once.
 */
export function startAgeGate() {
  if (!config.featureAgeGate) return;
  (window as Window & { AGE_GATE_CONFIG?: { ageGateExitUrl: string } }).AGE_GATE_CONFIG = {
    ageGateExitUrl: config.ageGateExitUrl,
  };
  if (document.querySelector(`script[src="${AGE_GATE_SCRIPT}"]`)) return;
  const script = document.createElement("script");
  script.src = AGE_GATE_SCRIPT;
  document.head.appendChild(script);
}
